// This must always be first
import "./require";

// Third-party dependencies
import "popper.js";
import "bootstrap";
import "lazysizes";
import "lazysizes/plugins/object-fit/ls.object-fit.js";
import "lazysizes/plugins/parent-fit/ls.parent-fit.js";
import "lazysizes/plugins/respimg/ls.respimg.js";
import "fluidbox";
import "smartmenus";
import "smartmenus/dist/addons/bootstrap-4/jquery.smartmenus.bootstrap-4.js";

// Theme scripts
import { AdvancedForm } from "./advanced-forms";
import { iframeResize, loadInFrame } from "./ajax-iframe";
import { getScrollbarWidth } from "./css-vars";
import { better_wpcf7_forms } from "./forms";
import { ajax_search } from "./search";
import { woocommerceFeatures } from "./woocommerce";
import { shareButtons } from "./share-buttons";

const $ = jQuery;

$( () => {

  $( 'form.af-form' ).each( function ( this: HTMLFormElement ) {
    new AdvancedForm( this );
  } );

  document.documentElement.style.setProperty( '--scrollbar-width', getScrollbarWidth() + 'px' );

  ajax_search();
  woocommerceFeatures();
  loadInFrame(); // loads content into iframe
  iframeResize(); // Automatically resizes iframes
  shareButtons();

  better_wpcf7_forms();
  $( '.gallery a.thumbnail' ).fluidbox();
  $( '.gallery a.thumbnail img' ).each( function ( this: HTMLImageElement ) {
    if ( this.src !== this.getAttribute( 'src' ) ) {
      $( this ).replaceWith( $( this.outerHTML ) );
    }
  } );

  // flyout menu
  $( '.navbar-collapse.width' ).on( 'show.bs.collapse hide.bs.collapse', function ( e ) {
    $( 'body' ).toggleClass( 'menu-visible' );
  } );

  //about page collapse
  //$('.our-team-block .fl-post-more-link a').attr('data-toggle', 'collapse');
  $('.our-team-block .fl-post-content').attr('class', 'collapse');

  $('.our-team-block .collapse').each(function(index){
    $(this).attr('id', 'collapse-' + index);
    $(this).parents('.our-team-block').find('.fl-post-more-link a').attr("href", "#collapse-" + index);
    $(this).on('shown.bs.collapse', function () {
      $(this).parents('.our-team-block').find('.fl-post-more-link a').text('Read Less');
    })
    $(this).on('shown.bs.collapse', function () {
      $(this).parents('.our-team-block').find('.fl-post-more-link a').text('Read Less');
    })
    $(this).on('hidden.bs.collapse', function () {
      $(this).parents('.our-team-block').find('.fl-post-more-link a').text('Read More');
    })
  });

  //contact page radio button change
  $('.radio-buttons input').on( 'change', function(){
    var $this = $(this);
    if ($this.is(':checked')) {
      $('.radio-buttons label').removeClass('active');
      $this.parent('label').addClass('active');
    }
  });

} );
